import { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
import { scrollToId } from '../../lib/smooth';
import { trackClick } from '../../lib/track';

export const StickyCTA = () => {
  const [show, setShow] = useState(false);

  useEffect(() => {
    const onScroll = () => setShow(window.scrollY > window.innerHeight * 0.85);
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <AnimatePresence>
      {show && (
        <motion.button
          data-testid="sticky-cta-button"
          initial={{ y: 90, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: 90, opacity: 0 }}
          transition={{ duration: 0.45, ease: [0.22, 1, 0.36, 1] }}
          onClick={() => {
            trackClick('sticky-baixar-aplicativo', 'aplicativo');
            scrollToId('#precos');
          }}
          className="bg-gold fixed inset-x-5 bottom-5 z-50 flex items-center justify-center gap-2 rounded-full py-3.5 text-[12px] font-bold uppercase tracking-[0.2em] text-black shadow-[0_10px_40px_rgba(212,175,55,0.35)] md:hidden"
        >
          Baixar o aplicativo agora
          <ArrowRight className="h-4 w-4" strokeWidth={2.5} />
        </motion.button>
      )}
    </AnimatePresence>
  );
};
